import useDiscard from "../../../useDiscard";
import useWeakMap from "../../../utils/useWeakMap";
import { isLayer } from "../validator/useLayerIdentity";
import useLogStack from "../../utils/useLogStack";
import { deleteLayerUsingOriginalSource, storeLayerUsingOriginalSource } from "./useStoreLayerUsingOriginalSource";
import { deleteLinkingLayer } from "./useStoreRefLayer";

const store = useWeakMap();

const onDiscardLayer = (layer) => {
    store.delete(layer);
}

const useQueryOriginalSourceByLayer = (layer) => {
    return store.get(layer);
}

export const storeOriginalSourceByLayer = (layer, originalSource) => {
    if (store.has(layer)) return;
    if (!isLayer(layer)) {
        throw 'storeOriginalSourceByLayer "layer" must be a layer'
    };
    useLogStack("storeOriginalSourceByLayer", layer, originalSource)
    if (isLayer(originalSource)) {
        originalSource = useQueryOriginalSourceByLayer(originalSource);
        if (!originalSource) throw new Error('originalSource not allow Layer')
    }
    store.set(layer, originalSource);
    storeLayerUsingOriginalSource(originalSource, layer);
    useDiscard(layer, onDiscardLayer);
}

export const swapLayerUsingOriginalSource = (layer, newOriginalSource, key) => {
    const oldOriginSource = store.get(layer);
    useLogStack("swapLayerUsingOriginalSource", layer, newOriginalSource)
    // Disconnect ref from current
    if (oldOriginSource) {
        deleteLayerUsingOriginalSource(oldOriginSource, layer);
    }
    store.set(layer, newOriginalSource);
    storeLayerUsingOriginalSource(newOriginalSource, layer, key);
}


export default useQueryOriginalSourceByLayer